import styled from '@emotion/styled';

import { TablePanel } from '@/components/common/Panel/style';
import { pageSectionLayout } from '@/styles/pageLayout';

export { TablePanel };

export const CommitteeListContainer = styled.div`
	${pageSectionLayout}
	display: flex;
	flex-direction: column;
	gap: 3.2rem;
`;

export const Table = styled.div`
	display: grid;
	grid-template-columns: 1.2fr 1.2fr 0.8fr 1.2fr 0.8fr 3.8fr;
	grid-auto-rows: minmax(5.2rem, auto);
	width: 100%;
	border-left: 1px solid #dee2e6;
	border-top: 1px solid #dee2e6;
`;

export const HeaderCell = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1.2rem 1.4rem;
	background-color: ${(props) => props.theme.colors.primary400};
	color: #fff;
	border-right: 1px solid #dee2e6;
	border-bottom: 1px solid #dee2e6;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	text-align: center;
	word-break: keep-all;
`;

export const Cell = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1.2rem 1.4rem;
	background-color: #fff;
	border-right: 1px solid #dee2e6;
	border-bottom: 1px solid #dee2e6;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.lineHeight.normal};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	color: #212529;
	text-align: center;
	word-break: keep-all;
	overflow-wrap: anywhere;
	&.section {
		font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	}
	&.members {
		padding: 1.6rem 2rem;
	}
`;
